import { makeApiTypes } from 'sidecar-utility-library'

export const types = {
  // care detail
  ...makeApiTypes('FETCH_CARE_EPISODE', 'careDetail'),
  ...makeApiTypes('FETCH_CARE_DETAIL', 'careDetail'),
  ...makeApiTypes('FETCH_DOCTOR_PRICING', 'careDetail'),
  ...makeApiTypes('FETCH_RX_PRICING', 'careDetail'),
  ...makeApiTypes('FETCH_DOCTORS_IN_FACILITY', 'careDetail'),
  CLEAR_CARE_DETAIL: 'careDetail/CLEAR_CARE_DETAIL',
  // Claims `detail.requestId` before a cacheable detail request is dispatched,
  // because a cache hit is answered without a REQUEST ever firing. See
  // `fetchSimpleCareEpisode`.
  AWAIT_CARE_DETAIL: 'careDetail/AWAIT_CARE_DETAIL',
  // care search
  RESET_CARE_SEARCH: 'careSearch/RESET_CARE_SEARCH',
  ...makeApiTypes('FETCH_CARE_FILTERS', 'careSearch'),
  ...makeApiTypes('FETCH_CARE_SEARCH', 'careSearch'),
  ...makeApiTypes('FETCH_PRECHECKED_PROVIDERS', 'careSearch'),
  RESET_PRECHECKED_PROVIDERS: 'careSearch/RESET_PRECHECKED_PROVIDERS',
  // prescriptions
  ...makeApiTypes('FETCH_PRESCRIPTIONS', 'prescription'),
  ...makeApiTypes('FETCH_RX_BY_KEYWORD', 'prescription'),
  // public care (coverage preview)
  ...makeApiTypes('FETCH_PUBLIC_CARE_FILTERS', 'publicCare'),
  ...makeApiTypes('FETCH_PUBLIC_CARE_SEARCH', 'publicCare'),
  ...makeApiTypes('FETCH_PUBLIC_CARE_DETAIL', 'publicCare'),
  RESET_PUBLIC_CARE_SEARCH: 'publicCare/RESET_PUBLIC_CARE_SEARCH',
  RESET_PUBLIC_CARE_DETAIL: 'publicCare/RESET_PUBLIC_CARE_DETAIL',
  // doctor care rates (care v2)
  ...makeApiTypes('FETCH_DOCTOR_RATES', 'careRates'),
  FETCH_DOCTOR_RATES_PRACTICE_SUCCESS:
    'careRates/FETCH_DOCTOR_RATES_PRACTICE_SUCCESS',
  UPDATE_CARE_RATE_BOOKMARK: 'careRates/UPDATE_CARE_RATE_BOOKMARK',
  CLEAR_CARE_RATES: 'care/CLEAR_CARE_RATES',
  // rating area
  ...makeApiTypes('FETCH_RATING_AREA', 'care'),
  // Member Communication Prechecked Providers
  ...makeApiTypes('FETCH_MEMBER_COMMS_PRECHECKED_PROVIDERS', 'memberComms'),
  CLEAR_MEMBER_COMMS_PRECHECKED_PROVIDERS:
    'memberComms/CLEAR_MEMBER_COMMS_PRECHECKED_PROVIDERS',
  // Pharmacy detail by NCPDP
  ...makeApiTypes('FETCH_PHARMACY_BY_NCPDP', 'pharmacy'),
  CLEAR_PHARMACY_DETAIL: 'pharmacy/CLEAR_PHARMACY_DETAIL',
}

export const initialState = {
  commonCare: {
    busy: false,
    error: '',
    entities: [],
  },
  history: {
    fetching: false,
    error: '',
    entities: [],
  },
  detail: {
    busy: false,
    pricingBusy: false,
    error: '',
    entity: {},
    // Id of the most recent detail request. Responses that don't match are
    // discarded so a slow request for a previous care item can't overwrite the
    // one the user is actually looking at (BASH-219).
    requestId: null,
  },
  publicDetail: {
    busy: false,
    pricingBusy: false,
    error: '',
    entity: {},
  },
  searchResults: {
    busy: false,
    page: null,
    size: 25,
    isLastPageReached: false,
    entities: [],
    // The query and member these results belong to. Results for any other
    // context are discarded rather than merged in (BASH-100). Keyed on the
    // search context rather than a per-request id so "show more" pagination
    // still merges. See `buildSearchContextMeta`.
    requestKey: null,
  },
  publicSearchResults: {
    busy: false,
    page: null,
    size: 25,
    isLastPageReached: false,
    entities: [],
  },
  careFilters: {
    busy: false,
    filters: {},
    error: '',
  },
  // Care Search/Detail/Episodes page prechecked providers
  precheckedProviders: {
    busy: false,
    error: '',
    entities: [],
  },
  prescriptions: {
    busy: false,
    error: '',
    entities: [],
  },
  // Care
  previewCoverage: {
    busy: false,
    error: '',
    insuranceFilingUuid: '',
    // state only set when checking zip param (don't use)
    state: '',
  },
  careRates: {
    busy: false,
    pricingBusy: false,
    error: '',
    page: null,
    size: 25,
    isLastPageReached: false,
    entities: [],
    apiCallId: null,
    // The provider type and monitoringId these rates belong to. The BE issues a
    // new monitoringId whenever the care item, its filters, or the map location
    // change; the provider type is in the key as well because individual
    // providers and practices share these action types and can share a
    // monitoringId. Rates from any other context are discarded rather than
    // merged into the current provider list. Keyed on context rather than a
    // per-request id so "show more" still merges. See `buildRateContextMeta`.
    requestKey: null,
  },
  ratingArea: {
    busy: 0,
    error: '',
    entity: {},
  },
  // Member comms prechecked providers used on the PLA form
  memberCommsPrecheckedProviders: {
    busy: false,
    error: '',
    entities: [],
  },
  // Individual pharmacy detail by NCPDP
  pharmacy: {
    busy: false,
    error: null,
    entity: null,
    // Id of the most recent pharmacy request; see `detail.requestId`.
    requestId: null,
  },
}
